package com.evoapps.evoshift.ui.workplaces

import androidx.compose.runtime.Composable

/**
 * Browsers have no geocoder of their own: addresses are searched on OpenStreetMap through the
 * geocodeAddress function (SH-132), never from the browser directly.
 */
@Composable
actual fun rememberPlatformAddressGeocoder(): AddressGeocoder? = null
